<div class="container mx-auto px-4 py-8 max-w-6xl">
  <!-- New Messages Notification (at top of page) -->
  <div *ngIf="messageUnreadCount > 0" 
       (click)="scrollToMessages()"
       class="mb-4 bg-gradient-to-r from-red-500 to-red-600 text-white p-4 rounded-lg shadow-2xl cursor-pointer hover:from-red-600 hover:to-red-700 transition-all transform hover:scale-[1.02] animate-pulse">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="bg-white bg-opacity-20 rounded-full p-2">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
          </svg>
        </div>
        <div>
          <p class="font-bold text-lg">{{ messageUnreadCount }} neue {{ messageUnreadCount === 1 ? 'Nachricht' : 'Nachrichten' }}</p>
          <p class="text-sm opacity-90">Klicken Sie hier, um {{ messageUnreadCount === 1 ? 'sie' : 'diese' }} anzuzeigen</p>
        </div>
      </div>
      <svg class="w-8 h-8 opacity-75" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </div>
  </div>
  
  <div class="bg-white rounded-lg shadow-2xl">
    <!-- Header -->
    <div class="sticky top-0 bg-gradient-to-r from-brand-primary to-brand-accent text-white p-6 flex justify-between items-center border-b z-10">
      <div>
        <h1 class="text-3xl font-bold">Buchung bearbeiten</h1>
        <p class="text-sm opacity-90 mt-1">{{ (editingBooking?.firstName || '') + ' ' + (editingBooking?.lastName || '') || editingBooking?.customerName }}</p>
      </div>
      <div class="flex items-center gap-3">
        <!-- Button zur Kundenansicht -->
        <button
          *ngIf="editingBooking"
          (click)="openCustomerView()"
          class="flex items-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg transition-all"
          title="Kundenansicht öffnen">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
          </svg>
          <span class="font-medium">Kundenansicht</span>
        </button>
        
        <button 
          (click)="navigateBack()"
          class="text-white hover:bg-white hover:text-brand-primary rounded-full p-2 transition">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-8 space-y-8">
        <div *ngIf="!editingBooking" class="text-center text-gray-600 py-8">
          <p>Keine Buchung ausgewählt</p>
        </div>

        <form *ngIf="editingBooking" class="space-y-8" (ngSubmit)="saveBooking()">
          <!-- Buchungs-ID & Status -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div class="bg-gray-50 p-4 rounded-lg">
              <p class="text-sm text-gray-600">Buchungs-ID</p>
              <p class="font-mono text-lg font-bold break-all text-brand-accent">{{ formatBookingId(editingBooking.id) }}</p>
            </div>
            
            <div class="bg-gray-50 p-4 rounded-lg">
              <label class="block text-sm text-gray-600 mb-2">📊 Status</label>
              <select 
                [(ngModel)]="editingBooking.status"
                name="status"
                class="w-full px-4 py-2 border rounded-lg bg-white text-gray-700 font-medium focus:outline-none focus:ring-2 focus:ring-brand-accent">
                <option value="New">Neu</option>
                <option value="Confirmed">✓ Bestätigt</option>
                <option value="Cancelled">✗ Storniert</option>
              </select>
            </div>
          </div>

          <!-- Auftragsbestätigung Button -->
          <div class="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-lg border-2 border-purple-200">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h3 class="text-lg font-bold text-purple-900 mb-2 flex items-center gap-2">
                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  Auftragsbestätigung in Sevdesk
                </h3>
                <p class="text-sm text-purple-700">
                  <span *ngIf="!editingBooking.sevdeskOrderId">Noch keine Auftragsbestätigung erstellt</span>
                  <span *ngIf="editingBooking.sevdeskOrderId">Sevdesk Order ID: {{ editingBooking.sevdeskOrderId }}</span>
                </p>
              </div>
              <button
                type="button"
                (click)="createOrUpdateOrderConfirmation()"
                [disabled]="isCreatingOrderConfirmation"
                class="px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-bold rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
                <svg *ngIf="!isCreatingOrderConfirmation" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                <svg *ngIf="isCreatingOrderConfirmation" class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span *ngIf="!editingBooking.sevdeskOrderId">AB erstellen</span>
                <span *ngIf="editingBooking.sevdeskOrderId">AB aktualisieren</span>
              </button>
              <button
                *ngIf="editingBooking.sevdeskOrderId"
                type="button"
                (click)="deleteOrderConfirmation()"
                [disabled]="isCreatingOrderConfirmation"
                class="px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 text-white font-bold rounded-lg hover:from-red-700 hover:to-red-800 transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
                <span>AB löschen</span>
              </button>
            </div>
          </div>

          <!-- Preisübersicht -->
          <div class="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-lg border-2 border-gray-200">
            <h2 class="text-xl font-bold mb-4 pb-2 border-b-2 border-brand-accent flex items-center gap-2">
              💰 Preisübersicht & Details
            </h2>
            
            <!-- Hauptpreise -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div class="bg-gradient-to-br from-blue-50 to-blue-100 p-4 rounded-lg border border-blue-200">
                <p class="text-sm text-blue-600 font-medium">Gesamtpreis</p>
                <p class="text-2xl font-bold text-blue-900">€{{ editingBooking.price | number:'1.2-2' }}</p>
                <p class="text-xs text-blue-600 mt-1">{{ editingBooking.durationDays }} Tage</p>
              </div>
              <div class="bg-gradient-to-br from-green-50 to-green-100 p-4 rounded-lg border border-green-200">
                <p class="text-sm text-green-600 font-medium">Einfache Entfernung</p>
                <p class="text-2xl font-bold text-green-900">{{ editingBooking.distance }} km</p>
              </div>
              <div class="bg-gradient-to-br from-amber-50 to-amber-100 p-4 rounded-lg border border-amber-200">
                <p class="text-sm text-amber-600 font-medium">👷 Helfer</p>
                
                <div class="mt-3 space-y-2">
                  <!-- Wenn Helfer nicht gebucht -->
                  <div *ngIf="!editingBooking.customerProvidesHelper">
                    <p class="text-sm text-amber-700 font-medium">Anzahl Personen zur Auslieferung benötigt</p>
                    <p class="text-lg font-bold text-amber-900">2</p>
                    <p *ngIf="editingBooking.helperDiscount && editingBooking.helperDiscount < 0" 
                       class="text-sm text-amber-700 mt-2 font-medium">
                      möglicher Rabatt: <span class="text-lg font-bold text-amber-900">€{{ editingBooking.helperDiscount | number:'1.2-2' }}</span>
                    </p>
                  </div>
                  
                  <!-- Wenn Helfer gebucht -->
                  <div *ngIf="editingBooking.customerProvidesHelper">
                    <p class="text-sm text-amber-700 font-medium">Anzahl Personen zur Auslieferung benötigt</p>
                    <p class="text-lg font-bold text-amber-900">1</p>
                    <p *ngIf="editingBooking.helperDiscount && editingBooking.helperDiscount < 0" 
                       class="text-sm text-amber-700 mt-2 font-medium">
                      angerechneter Rabatt: <span class="text-lg font-bold text-amber-900">€{{ editingBooking.helperDiscount | number:'1.2-2' }}</span>
                    </p>
                    <p class="text-xs text-amber-600 mt-2 italic">Kunde stellt eigenen Helfer</p>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Detaillierte Kostenaufschlüsselung -->
            <div *ngIf="editingBooking.lineItems && editingBooking.lineItems.length > 0" class="bg-white p-4 rounded-lg border border-gray-300">
              <h3 class="text-lg font-semibold mb-3 text-gray-800">📋 Detaillierte Kostenaufschlüsselung</h3>
              <div class="space-y-2">
                <div *ngFor="let item of editingBooking.lineItems" class="flex justify-between items-start py-2 border-b border-gray-200 last:border-b-0">
                  <div class="flex-1">
                    <p class="font-medium text-gray-800">{{ item.description }}</p>
                    <p *ngIf="item.quantity > 1" class="text-xs text-gray-500">{{ item.quantity }} × €{{ item.unitPrice | number:'1.2-2' }}</p>
                  </div>
                  <p class="font-semibold text-gray-900 ml-4">€{{ item.totalPrice | number:'1.2-2' }}</p>
                </div>
              </div>
              <div class="mt-4 pt-3 border-t-2 border-gray-300 flex justify-between items-center">
                <p class="text-lg font-bold text-gray-900">Gesamtsumme (netto)</p>
                <p class="text-2xl font-bold text-brand-primary">€{{ editingBooking.price | number:'1.2-2' }}</p>
              </div>
            </div>
            
            <!-- 360° Branding falls vorhanden -->
            <div *ngIf="editingBooking.includes360Branding" class="mt-4 bg-purple-50 p-4 rounded-lg border border-purple-200">
              <div class="flex justify-between items-center">
                <div>
                  <p class="text-sm text-purple-600 font-medium">360° Branding</p>
                  <p class="text-xs text-purple-500 mt-1">{{ editingBooking.brandingRequiresAdvanceBooking ? '14 Tage Vorlauf erforderlich' : '' }}</p>
                </div>
                <p class="text-xl font-bold text-purple-900">
                  €{{ editingBooking.brandingPrice ? (editingBooking.brandingPrice | number:'1.2-2') : 'TBD' }}
                </p>
              </div>
            </div>
          </div>

          <!-- Zwei-Spalten Layout -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <!-- Linke Spalte: Kundendaten -->
            <div class="space-y-6">
              <div>
                <h2 class="text-xl font-bold mb-4 pb-2 border-b-2 border-brand-accent">👤 Kundendaten</h2>
                
                <div class="space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Vorname *</label>
                      <input 
                        type="text"
                        [(ngModel)]="editingBooking.firstName"
                        name="firstName"
                        disabled
                        class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Nachname *</label>
                      <input 
                        type="text"
                        [(ngModel)]="editingBooking.lastName"
                        name="lastName"
                        disabled
                        class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                    </div>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Firma</label>
                    <input 
                      type="text"
                      [(ngModel)]="editingBooking.companyName"
                      name="companyName"
                      disabled
                      class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">E-Mail</label>
                    <input 
                      type="email"
                      [(ngModel)]="editingBooking.email"
                      name="email"
                      disabled
                      class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Adresse</label>
                    <textarea 
                      [(ngModel)]="editingBooking.address"
                      name="address"
                      disabled
                      rows="3"
                      class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700"></textarea>
                  </div>
                </div>
              </div>

              <!-- Mietdaten -->
              <div>
                <h2 class="text-xl font-bold mb-4 pb-2 border-b-2 border-brand-accent">📅 Mietdaten</h2>
                
                <div class="space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Von</label>
                      <input 
                        type="text"
                        [value]="editingBooking.startDate | date:'dd.MM.yyyy HH:mm'"
                        disabled
                        class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Bis</label>
                      <input 
                        type="text"
                        [value]="editingBooking.endDate | date:'dd.MM.yyyy HH:mm'"
                        disabled
                        class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                    </div>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Dauer</label>
                      <input 
                        type="text"
                        [value]="editingBooking.durationDays + ' Tage'"
                        disabled
                        class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Entfernung</label>
                      <input 
                        type="text"
                        [value]="editingBooking.distance + ' km'"
                        disabled
                        class="w-full px-4 py-2 border rounded-lg bg-gray-100 text-gray-700">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Rechte Spalte: 360° Branding -->
            <div class="space-y-6">
              <!-- 360° Branding -->
              <div *ngIf="editingBooking.includes360Branding" class="bg-blue-50 p-4 rounded-lg border-2 border-blue-200">
                <h2 class="text-xl font-bold mb-4 pb-2 border-b-2 border-blue-200">🎨 360° Branding</h2>
                
                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-blue-900 mb-1">Branding-Preis (€)</label>
                    <input 
                      type="number"
                      step="0.01"
                      [(ngModel)]="editingBooking.brandingPrice"
                      name="brandingPrice"
                      class="w-full px-4 py-2 border rounded-lg text-sm">
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-blue-900 mb-1">Branding-Notizen</label>
                    <textarea 
                      [(ngModel)]="editingBooking.brandingNotes"
                      name="brandingNotes"
                      rows="3"
                      class="w-full px-4 py-2 border rounded-lg text-sm"
                      placeholder="z.B. Grafik-Spezifika, Anmerkungen..."></textarea>
                  </div>

                  <div class="flex items-center p-2 bg-blue-100 rounded">
                    <input 
                      type="checkbox"
                      [(ngModel)]="editingBooking.brandingRequiresAdvanceBooking"
                      name="brandingRequiresAdvanceBooking"
                      id="brandingRequiresAdvanceBooking"
                      class="w-4 h-4 text-brand-accent rounded border-gray-300">
                    <label for="brandingRequiresAdvanceBooking" class="ml-2 text-sm font-medium text-blue-900">14 Tage Vorlauf erforderlich</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Allgemeine Notizen -->
          <div>
            <h2 class="text-xl font-bold mb-4 pb-2 border-b-2 border-brand-accent">📝 Notizen</h2>
            <textarea 
              [(ngModel)]="editingBooking.notes"
              name="notes"
              rows="5"
              class="w-full px-4 py-3 border rounded-lg text-sm"
              placeholder="Notizen zur Buchung (z.B. spezielle Anforderungen, Kontaktinformationen, wichtige Details)..."></textarea>
          </div>

          <!-- Zeitstempel -->
          <div class="bg-gray-50 p-4 rounded-lg text-sm text-gray-600 space-y-1">
            <p>Erstellt: {{ editingBooking.createdAt | date:'dd.MM.yyyy HH:mm' }}</p>
            <p *ngIf="editingBooking.updatedAt">Zuletzt aktualisiert: {{ editingBooking.updatedAt | date:'dd.MM.yyyy HH:mm' }}</p>
          </div>

          <!-- Action Buttons -->
          <div class="flex gap-3 pt-6 border-t sticky bottom-0 bg-white py-6">
            <button 
              type="submit"
              [disabled]="isSaving"
              class="flex-1 px-6 py-3 bg-gradient-to-r from-brand-primary to-brand-accent text-white rounded-lg hover:shadow-lg font-bold transition disabled:opacity-50">
              {{ isSaving ? '💾 Speichern' : '💾 Speichern' }}
            </button>
            <button 
              type="button"
              (click)="navigateBack()"
              [disabled]="isSaving"
              class="flex-1 px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 font-bold transition disabled:opacity-50">
              ✕ Schließen
            </button>
          </div>
        </form>
        
        <!-- Message Chat - AUSSERHALB des Forms, damit Nachrichtensenden nicht die Buchung speichert -->
        <div class="mt-8">
          <h2 class="text-xl font-bold mb-4 pb-2 border-b-2 border-brand-accent">💬 Kommunikation</h2>
          <app-message-chat 
            #messageChatComponent
            *ngIf="originalBookingId"
            [bookingId]="originalBookingId" 
            [isAdmin]="true"
            (unreadCountChange)="onUnreadCountChange($event)">
          </app-message-chat>
        </div>
      </div>
    </div>
  </div>
